import React, {useEffect, useState} from 'react';

import { useNavigate} from "react-router-dom";

import CanvasJSChart from "./ReactCanvasJSChart";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import { getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getAdminSectionRAGStats, getProviderSectionRAGStats} from "root/DataFunctions/ChartFns";

import { RagStatusValues } from "root/ReactHookForm/ui/ReactRAGStatus";

const DashboardPanelAdminRAGBarStats= ({title='Title', id, survey_type, panelStyle='panel-default'}) =>
{
	const [ data, setData ] = useState ( { loading: true, data: [], dataPoints: []})
	const [ navigator, setNavigator ] = useState ( { isNavigating: false, url: ''})

	const navigate = useNavigate() ;

	useEffect(() =>
	{
		getServerData() ;
	}, []);

	const onRowClick = ( e ) =>
	{
		const url = "/dashboard/rag_report/" + e.dataPoint.id ;

		navigate(url);
	}

	const getServerData = () =>
	{
		getAdminSectionRAGStats('current', survey_type, (response) =>
		{
			const reportData = getDataFromResponse(response);

			const amber = reportData.map ((row) =>
			{
				const scores = row.scores ;

				const countAmber = scores.reduce((cur, rec) =>
				{
					if ( +(rec.status) === RagStatusValues.AMBER )
					{
						cur = +(rec.count) ;
					}
					return cur ;
				}, 0);

				return { label: 'S' + row.table_section_id,
						 y: countAmber,
						 id: row.table_section_id }
			}) ;

			const red = reportData.map ((row) =>
			{
				const scores = row.scores ;

				const count = scores.reduce((cur, rec) =>
				{
					if ( +(rec.status) === RagStatusValues.RED )
					{
						cur = +(rec.count) ;
					}

					return cur ;
				}, 0);

				const label = row.section_name_abbrev === null ? 'S ' + row.table_section_id : row.section_name_abbrev ;

				return { label: label,
					y: count,
					id: row.table_section_id }
			}) ;

			const green = reportData.map ((row) =>
			{
				const scores = row.scores ;

				const count = scores.reduce((cur, rec) =>
				{
					if ( +(rec.status) === RagStatusValues.GREEN )
					{
						cur = +(rec.count) ;
					}
					return cur ;
				}, 0);

				return { label: 'S ' + row.table_section_id,
					y: count,
					id: row.table_section_id }
			}) ;

			const unscored = reportData.map ((row) =>
			{
				const scores = row.scores ;

				const count = scores.reduce((cur, rec) =>
				{
					if ( +(rec.status) === RagStatusValues.UNSET )
					{
						cur = +(rec.count) ;
					}
					return cur ;
				}, 0);

				return { label: 'Standard ' + row.table_section_id,
					y: count,
					id: row.table_section_id }
			}) ;

			const graphData = [
				{
					type: "stackedColumn",
					name: "Not Scored",
					showInLegend: false,
					color: "#f0f1f0",
					click: onRowClick,
					dataPoints: unscored,
				},
				{
					type: "stackedColumn",
					name: "Green",
					showInLegend: false,
					color: "#92D050",
					click: onRowClick,
					dataPoints: green,
				},
				{
					type: "stackedColumn",
					name: "Amber",
					showInLegend: false,
					color: "#FFC000",
					click: onRowClick,
					cursor: 'pointer',
					dataPoints: amber
				},
				{
					type: "stackedColumn",
					name: "Red",
					showInLegend: false,
					color: "#e63f22",
					click: onRowClick,
					dataPoints: red,
				},
			] ;

			setData({loading: false, dataPoints: graphData, data: reportData }) ;
		});

	}

	const formPanel = () =>
	{
		const options = {
			animationEnabled: true,
			height: 400,
			backgroundColor: "#FAFBFD",

			title: {
				text: "",
				fontColor: '#333',
				fontSize: 18,
				fontWeight: 'lighter',
				fontFamily: 'tahoma',
				padding: 20
			},
			axisX:{
				title:'',
				titleFontColor: '#333',
				titleFontSize: 14,
				//titleFontWeight: 'lighter',
				titleFontFamily: 'tahoma',
				margin: 50,
				tickLength: 0
			},
			axisY: {
				title: "Questions",
				interlacedColor: "white",
				titleFontSize: 14,
				gridColor: "white",
				titleFontFamily: 'tahoma',
				tickLength: 0
			},
			legend: {
				verticalAlign: "center",
				horizontalAlign: "right",
				reversed: true,
				cursor: "pointer",
				fontSize: 16,
			},
			toolTip: {
				shared: true
			},

			data: data.dataPoints
		};

		return (
			<div className={'panel ' + panelStyle}>
				{ getPanelHeader({ title: title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartAdminRag' options={options} uniqueId={'canvas'+ id}/>
				</div>
			</div>
		)
	}

	if ( data.loading === true )
	{
		return <SpinnerDiv/>
	}
	else
	{
		return formPanel() ;
	}

};

export default DashboardPanelAdminRAGBarStats;

